var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import "./moveable.css";
import "../core/polyfills";
import { EventHandler } from "./eventhandler";
var defaultOptions = {
    onStart: new EventHandler(),
    onStop: new EventHandler(),
    onMove: new EventHandler(),
    direction: "both",
    moveDelta: 0,
    containInParent: true
};
var MoveableContainer = /** @class */ (function () {
    function MoveableContainer(container, options) {
        var _this = this;
        this.container = container;
        this.options = options;
        this.resizeX = false;
        this.resizeY = false;
        this.initialX = null;
        this.initialY = null;
        this.startSize = { x: null, y: null };
        this.mouseDownContainer = function (evt) {
            var target = evt.target;
            var directChild = target;
            while (directChild.parentElement != null && directChild.parentElement !== _this.container) {
                if (_this.options.selector != null && directChild.matches(_this.options.selector)) {
                    break;
                }
                directChild = directChild.parentElement;
            }
            if (directChild.parentElement == null) {
                return;
            }
            if (_this.options.selector != null && !directChild.matches(_this.options.selector)) {
                return;
            }
            _this.element = directChild;
            var canceled = false;
            var args = {
                evt: evt,
                target: _this.element,
                x: _this.element.offsetLeft,
                y: _this.element.offsetTop,
                cancelEvent: function () { canceled = true; }
            };
            _this.options.onStart.notify(args);
            if (canceled) {
                return;
            }
            evt.preventDefault();
            evt.stopPropagation();
            evt.stopImmediatePropagation();
            _this.initialX = _this.extractArg(evt, "clientX") - _this.element.offsetLeft;
            _this.initialY = _this.extractArg(evt, "clientY") - _this.element.offsetTop;
            // register event listeners
            window.addEventListener("mousemove", _this.mouseMove, false);
            window.addEventListener("mouseup", _this.mouseUp, false);
            window.addEventListener("touchmove", _this.mouseMove, false);
            window.addEventListener("touchend", _this.mouseUp, false);
        };
        this.mouseMove = function (evt) {
            var raiseEvt = false;
            var x = 0;
            if (_this.resizeX) {
                var val = _this.extractArg(evt, "clientX");
                if (_this.startSize != null && _this.startSize.x == null) {
                    _this.startSize.x = val;
                }
                if (_this.startSize == null || Math.abs(_this.startSize.x - val) >= _this.options.moveDelta) {
                    //if (!this.options.gridX || Math.round(val) % this.options.gridX === 0) {
                    x = val - _this.initialX;
                    if (_this.options.gridX) {
                        x = Math.round(x / _this.options.gridX) * _this.options.gridX;
                    }
                    if (_this.options.containInParent) {
                        if (x < 0) {
                            x = 0;
                        }
                        var maxX = _this.container.clientWidth - _this.element.offsetWidth;
                        if (x > maxX) {
                            x = maxX;
                        }
                    }
                    _this.element.style.left = x + "px";
                    raiseEvt = true;
                    _this.startSize = null;
                    //}
                }
            }
            var y = 0;
            if (_this.resizeY) {
                var val = _this.extractArg(evt, "clientY");
                if (_this.startSize != null && _this.startSize.y == null) {
                    _this.startSize.y = val;
                }
                if (_this.startSize == null || Math.abs(_this.startSize.y - val) >= _this.options.moveDelta) {
                    //if (!this.options.gridY || Math.round(val) % this.options.gridY === 0) {
                    y = val - _this.initialY;
                    if (_this.options.gridY) {
                        y = Math.round(y / _this.options.gridY) * _this.options.gridY;
                    }
                    if (y < 0) {
                        y = 0;
                    }
                    var maxY = _this.container.clientHeight - _this.element.offsetHeight;
                    if (y > maxY) {
                        y = maxY;
                    }
                    _this.element.style.top = y + "px";
                    raiseEvt = true;
                    _this.startSize = null;
                    //}
                }
            }
            if (raiseEvt) {
                _this.options.onMove.notify({
                    evt: evt,
                    target: _this.element,
                    x: x,
                    y: y,
                    cancelEvent: function () { }
                });
            }
        };
        this.mouseUp = function (evt) {
            window.removeEventListener("mousemove", _this.mouseMove, false);
            window.removeEventListener("mouseup", _this.mouseUp, false);
            window.removeEventListener("touchmove", _this.mouseMove, false);
            window.removeEventListener("touchend", _this.mouseUp, false);
            _this.options.onStop.notify({
                evt: evt,
                target: _this.element,
                x: _this.element.offsetLeft,
                y: _this.element.offsetTop,
                cancelEvent: function () { }
            });
            _this.startSize = { x: null, y: null };
        };
        if (options.direction === "x" || options.direction === "both") {
            this.resizeX = true;
        }
        if (options.direction === "y" || options.direction === "both") {
            this.resizeY = true;
        }
        this.init();
    }
    MoveableContainer.prototype.init = function () {
        this.container.addEventListener("mousedown", this.mouseDownContainer, false);
        this.container.addEventListener("touchstart", this.mouseDownContainer, false);
    };
    MoveableContainer.prototype.extractArg = function (evt, key) {
        return evt[key] != null ? evt[key] : (evt.touches.length > 0 ? evt.touches : evt.changedTouches)[0][key];
    };
    return MoveableContainer;
}());
export { MoveableContainer };
export function Moveable(selector, options) {
    return new MoveableContainer(typeof selector === "string" ?
        document.querySelector(selector) :
        selector, __assign(__assign({}, defaultOptions), options));
}
